var DOUBLE_OPT_IN_CACHE_TAGS = {
  EMAIL_VERIFICATION_STATUS: 'EmailVerificationStatus',
  DOUBLE_OPT_IN: 'DoubleOptIn'
};
DOUBLE_OPT_IN_CACHE_TAGS.doubleOptInTagsArray = Object.values(DOUBLE_OPT_IN_CACHE_TAGS);
export { DOUBLE_OPT_IN_CACHE_TAGS };